module.exports = __webpack_public_path__ + "e413ee58c76c1032ed6770c84f3edf04.png";